'use client';

import { createRoute, useLocation, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { Route as rootRoute } from './__root';

const ADMIN_DESTINATION = {
  review: '/review',
  tasks: '/tasks',
  telemetry: '/telemetry',
} as const;
type LegacyAdminTab = keyof typeof ADMIN_DESTINATION;

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/admin',
  validateSearch: (
    search: Record<string, unknown>
  ): { tab: LegacyAdminTab } => ({
    tab: isLegacyAdminTab(search.tab) ? search.tab : 'review',
  }),
  component: AdminRedirect,
});

function isLegacyAdminTab(value: unknown): value is LegacyAdminTab {
  return typeof value === 'string' && value in ADMIN_DESTINATION;
}

function AdminRedirect() {
  const { tab } = Route.useSearch();
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    navigate({
      to: ADMIN_DESTINATION[tab],
      search: {},
      hash: location.hash.replace(/^#/, ''),
      replace: true,
    });
  }, [location.hash, navigate, tab]);
  return null;
}
